import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsFillMoonFill, BsFillSunFill } from "react-icons/bs";
import Switch from "react-switch";

const Header = ({ darkMode, handleDarkModeToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [expandedMenu, setExpandedMenu] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const updateWidth = () => {
    setIsDesktop(window.innerWidth >= 740);
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setExpandedMenu(false);
  }, [location.pathname]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (expandedMenu && !isDesktop) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [expandedMenu, isDesktop]);

  const toggleMenu = () => {
    setExpandedMenu(!expandedMenu);
  };

  const scrollHandler = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <header id="app-header" className="header">
        <div className="header-content">
          <a onClick={() => scrollHandler()}>
            <h1>Seth Mitchell</h1>
          </a>
          {isDesktop ? (
            <nav className="desktop">
              <Link
                to="/about"
                className={location.pathname.includes("about") ? "active" : ""}
              >
                About
              </Link>
              <Link
                to="/work"
                className={location.pathname.includes("work") ? "active" : ""}
              >
                Product Work
              </Link>
              <Link
                to="/experience"
                className={
                  location.pathname.includes("experience") ? "active" : ""
                }
              >
                Experience
              </Link>
              <label id="color-mode-toggle">
                <Switch
                  onChange={handleDarkModeToggle}
                  checked={darkMode ? true : false}
                  offColor="#D4D4D4"
                  onColor="#3C3C3C"
                  onHandleColor="#1B1B1B"
                  checkedIcon={<BsFillMoonFill />}
                  uncheckedIcon={<BsFillSunFill />}
                  height={35}
                  width={65}
                  handleDiameter={25}
                />
              </label>
            </nav>
          ) : (
            <button
              className={`mobile-menu-toggle ${expandedMenu ? "open" : ""}`}
              onClick={toggleMenu}
              aria-label={expandedMenu ? "Close menu" : "Open menu"}
              aria-expanded={expandedMenu}
            >
              <span className="hamburger-line" />
              <span className="hamburger-line" />
              <span className="hamburger-line" />
            </button>
          )}
        </div>
      </header>

      {!isDesktop && (
        <div
          className={`mobile-menu-overlay ${expandedMenu ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <nav
            className={`mobile-menu ${expandedMenu ? "open" : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <Link
              to="/about"
              className={location.pathname.includes("about") ? "active" : ""}
            >
              About
            </Link>
            <Link
              to="/work"
              className={location.pathname.includes("work") ? "active" : ""}
            >
              Product Work
            </Link>
            <Link
              to="/experience"
              className={
                location.pathname.includes("experience") ? "active" : ""
              }
            >
              Experience
            </Link>
            <label id="color-mode-toggle">
              <Switch
                onChange={handleDarkModeToggle}
                checked={darkMode ? true : false}
                offColor="#D4D4D4"
                onColor="#3C3C3C"
                onHandleColor="#1B1B1B"
                checkedIcon={<BsFillMoonFill />}
                uncheckedIcon={<BsFillSunFill />}
                height={35}
                width={65}
                handleDiameter={25}
              />
            </label>
          </nav>
        </div>
      )}
    </>
  );
};

export { Header };
